import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '@/views/HomeView.vue';
import ApplicationWizard from '@/views/ApplicationWizard.vue';
import { requireAuth } from '@/middleware/AuthGuard';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { requiresAuth: false },
  },
  
  {
    // path: '/form/:id/:type',
    path: '/form',
    name: 'application-wizard',
    component: ApplicationWizard,
    props: true,
    meta: { requiresAuth: true },
  },

  {
    path: '/processes/:id/phases/:phaseId/approved',
    name: 'approved-candidates',
    component: () => import('@/views/ApprovedCandidates.vue'),
    props: true,
    meta: { requiresAuth: false },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/silent-check-sso.html')) return next(false);

  if (to.matched.some(record => record.meta.requiresAuth)) {
    requireAuth(to, from, next);
  } else {
    next();
  }
});

export default router;
